export default {
  appTitle: 'Folios',
  dataTableHeaders: {
    id: 'ID Folio',
    coverageType: 'Tipo de folio',
  },
  addAuthorization: {
    creating: 'Creando folio...'
  }
}
